interface FlashcardFooterProps {
  children: React.ReactNode
}

export default function FlashcardFooter({ children }: FlashcardFooterProps) {
  return <div className="mt-10 flex h-[180px] w-full items-start justify-center">{children}</div>
}
